<section class="footer py-5 border-top bg-light">
    <div class="container-fluid px-lg-5 py-3">
        <div class="row g-4">
            <!-- Logo Section -->
            <div class="col-lg-3 text-center mb-4 d-flex align-items-center justify-content-center">
                <a href="https://lf.cktechsoln.in/">
                    <img src="../../../assets/img/new/frost’n-crunch.png" alt="Logo" class="img-fluid footer-logo">
                </a>
            </div>

            <!-- Google Map Section -->
            <div class="col-lg-6 mb-4 text-center">
                <iframe class="w-100 rounded shadow-sm" height="250" 
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5009.899027018716!2d78.093258!3d9.9226885!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2131002bffe29ab3%3A0x9b4074ac85717374!2sCKTech%20Solution%20Private%20Limited!5e1!3m2!1sen!2sin!4v1772433282876!5m2!1sen!2sin" width="600" height="350" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </div>

            <!-- Contact Section -->
            <div class="col-lg-3 d-lg-flex align-items-center justify-content-center">
                <div>
                    <h5 class="josefin-sans-bold text-dark">Contact Us</h5>
                <ul class="list-unstyled mt-3">
                    <li class="d-flex align-items-center mb-3">
                        <span class="josefin-sans-regular"> 15, Ponmeni Narayanan Street,<br> SS Colony, Madurai - 625016</span>
                    </li>
                    <li class="d-flex align-items-center mb-2">
                        <span class="josefin-sans-regular"> +91 9003028550 </span>
                    </li>
                    <!-- <li class="d-flex align-items-center">
                        <span class="josefin-sans-regular">demo&#64;company.com</span>
                    </li> -->
                </ul>
                </div>
            </div> 
        </div>
    </div>
</section>

<!-- Footer Bottom -->
<div class="footer_bottom bg-dark text-white py-3">
    <div class="container">
        <div class="row d-flex justify-content-between align-items-center text-center">
            <div class="col-lg-6">
                <p class="mb-0 josefin-sans-regular">&copy; <b>{{ currentYear }}</b> All rights reserved 
                </p>
            </div>
            <div class="col-lg-6 justify-content-between align-items-center text-center">
                <p class="mb-0 josefin-sans-regular">Designed & Developed by 
                    <a href="https://cktechsoln.in/" target="_blank" class="text-white text-decoration-none josefin-sans-bold">CKTech Solution Pvt Ltd Madurai.</a>
                </p>
            </div>
        </div>
    </div>
</div>
